<!--
 * @Author: your name
 * @Date: 2021-11-05 13:47:38
 * @LastEditTime: 2022-12-13 17:14:10
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\components\BjInputMobile\index.vue
-->
<template>
  <el-form-item :label="label" :prop="prop" :rules="rules || defaultRules" :size="size">
    <el-input
      v-if="!readonly"
      v-model="id"
      :disabled="disabled"
      :placeholder="placeholder || $t('inputText')"
      :clearable="clearable"
      maxlength="50"
      @keyup.native="proving($event)"
      @keyup.enter.native="handleQuery"
    />
    <span v-if="readonly">{{ id }}</span>
  </el-form-item>
</template>
<script>
import { patternCodeSimple } from '@/utils/validate';
export default {
  name: 'BjFormItemCode',
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    size: {
      type: String,
      default: 'mini',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: [String, Number],
      default: '编码',
    },
    placeholder: {
      type: String,
      default: '',
    },
    prop: {
      type: [String],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default: () => {
        return null;
      },
    },
    validator: Function,
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    defaultRules() {
      return [
        {
          validator: (rule, value, callback) => {
            if (typeof this.validator == 'function') {
              this.validator(rule, value, callback, this.label);
            } else {
              this.validatorCodeSimpleLabel(rule, value, callback, this.label);
            }
          },
          required: this.required,
          trigger: 'blur',
        },
      ];
    },
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
  methods: {
    validatorCodeSimpleLabel(rule, value, callback, label) {
      if (typeof value == 'number') value = String(value);
      if (!value) {
        if (rule.required) {
          callback(new Error(this.$t('inputText') + ' ' + label));
        } else {
          callback();
        }
      } else {
        if (!patternCodeSimple.test(String(value))) {
          callback(new Error(label + this.$t('formatErrorText')));
        } else {
          callback();
        }
      }
    },
    // 限制正整数输入
    proving(e) {
      this.$emit('proving');
    },
    handleQuery() {
      this.$emit('keyup.enter.native');
    },
  },
};
</script>
